module.exports = __webpack_public_path__ + "img/solid_bundle_promo.0e8c8ffd.png";